// @flow

import _ from 'lodash';

import ApiObject from './ApiObject';
import ApiConstants from '../constants/ApiConstants';
import DateUtils from '../utils/DateUtils';

// -- entities
import Check from './Check';

export default class Review extends ApiObject {

  id: string = '';

  restaurantId: string = '';

  comment: string = '';

  userId: string = '';

  rate: number = 0;

  checkId: string = '';

  paymentId: string = '';

  reasons: Array<String> = [];

  comment: string = '';

  creationDate: number = 0;

  userName: string = '';

  /**
   * Is deserialized, we populate him. See ApiReview #getReviewsSummary
   */
  check: ?Check = null;

  postJsonAssignation(data: Object) {
    this.creationDate = Math.floor(this.creationDate / 1000);
  }

  getFormattedDate(format: string = 'DD/MM/Y'): string {
    return DateUtils.fromSecondsTimestampToString(this.creationDate, format);
  }

  getFormattedHour(format: string = 'HH:mm'): string {
    return DateUtils.fromSecondsTimestampToString(this.creationDate, format);
  }

  getFormattedReasons() {
    const formattedReasons = [];
    const reasonsValues = ApiConstants.Review.REASONS;

    _.each(this.reasons, (reasonKey: string) => {
      const reasonValue = reasonsValues[reasonKey];

      if (!_.isUndefined(reasonValue)) {
        formattedReasons.push(reasonValue);
      } else {
        // TODO: send a message to the dev to handle this.
        console.error('reason key not found', reasonKey);
        formattedReasons.push(reasonKey);
      }
    });

    return formattedReasons;
  }

  havePayment(): boolean {
    return !_.isNull(this.paymentId) && !_.isNaN(this.paymentId);
  }

}



// WEBPACK FOOTER //
// ./sdk/scripts/entities/Review.js